import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
  Table,
} from "reactstrap"
import API from "../../../api"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"
import Select from "react-select"

const AddMunicipalite = props => {
  const [code, setCode] = useState("")
  const [etatCode, setEtatCode] = useState(false)
  const [gouvernerat, setGouvernerat] = useState([])
  const [selectGouvernerat, setSelectGouvernerat] = useState("")
  const [delegation, setDelegation] = useState([])
  const [selectDelegation, setSelectDelegation] = useState("")
  const [name, setName] = useState("")

  useEffect(async () => {
    const res = await API.get("gouvernerat/select").then(res => {
      setGouvernerat(res.data.Gouvernerat)
    })
  }, [])

  const getDelegation = e => {
    setSelectGouvernerat(e)
    const res = API.post("delegation/gouvernerat/delegation/select", {
      gouvernerat_id: e.value,
    }).then(res => {
      setDelegation(res.data.Delegation)
    })
  }

  const save = async () => {
    if (name != "" && code != "") {
      const res = await API.post("minicipalite/add", {
        delegation_id: selectDelegation.value,
        code: code,
        name: name,
      }).then(res => {
        if (res.data.status == 200) {
          setEtatCode(false)
          props.setSection(1)
        } else {
          setEtatCode(true)
        }
      })
    }
  }

  return (
    <React.Fragment>
      <div>
        <Row>
          {etatCode ? (
            <div className="alert alert-danger">
              <strong>Code deja utilisé!</strong>
            </div>
          ) : null}
          <AvForm>
            <Row>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    {props.t("Code")}
                  </Label>
                  <AvField
                    name="code"
                    placeholder=" Entrer code"
                    type="text"
                    errorMessage="* Code obligatoire"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    onChange={e => setCode(e.target.value)}
                    maxlength="5"
                  />
                </div>
              </Col>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    {props.t("Gouvernerat")}
                  </Label>
                  <Select
                    name="gouvernerat"
                    options={gouvernerat}
                    isSearchable={true}
                    onChange={getDelegation}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    {props.t("Délegation")}
                  </Label>
                  <Select
                    name="delegation"
                    options={delegation}
                    isSearchable={true}
                    onChange={setSelectDelegation}
                  />
                </div>
              </Col>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    {props.t("Désignation")}
                  </Label>
                  <AvField
                    name="designation"
                    placeholder="Entrer désignation"
                    type="text"
                    errorMessage="* Désignation obligatoire"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    onChange={e => setName(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Col lg="6">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                  className="text-center mt-4"
                >
                  <Button
                    type="button"
                    color="warning"
                    className="btn btn-warning  mb-2 me-2"
                    onClick={props.back}
                  >
                    {props.t("Annuler")}
                  </Button>
                </div>
              </Col>
              <Col lg="6">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                  className="text-center mt-4"
                >
                  <button
                    onClick={save}
                    type="submit"
                    className="btn btn-primary "
                  >
                    {props.t("Confirmer")}
                  </button>
                </div>
              </Col>
            </div>
          </AvForm>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default withTranslation()(AddMunicipalite)
AddMunicipalite.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
